import { Button } from "@au-schein-de/au-ui-library";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import { useCart } from "./cart.context";

interface CartItemPlaceholderProps {
	index: number;
}

export function CartItemPlaceholder({ index }: CartItemPlaceholderProps) {
	const { t } = useTranslation("cart");
	const [pending, setPending] = useState(false);

	const {
		cartDisclosure,
		remainingItemsLimit,
		remainingCapacity,
		pharmacyItems,
	} = useCart();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const goToProducts = async () => {
		setPending(true);

		const targetUrl = `/products?${searchParams.toString()}`;
		const currentUrl = `${window.location.pathname}${window.location.search}`;

		if (currentUrl !== targetUrl) {
			await navigate(`/products?${searchParams.toString()}`);
		}

		const defer = window.requestIdleCallback
			? window.requestIdleCallback
			: (cb: () => void) => setTimeout(cb, 10);

		defer(() => {
			cartDisclosure.close();
			setPending(false);
		});
	};

	return (
		<div className="w-full h-[90px] flex justify-between items-center border-1 border-dashed border-gray-300 rounded-xl px-3 mt-4">
			<p className="text-body-bold text-gray-500">
				{t("productIndexOfTotal", {
					index: index + 1,
					total: pharmacyItems.length + remainingItemsLimit,
				})}
			</p>

			<Button
				variant="secondary"
				size="md"
				onClick={goToProducts}
				pending={pending}
				disabled={remainingCapacity === 0}
				data-testid="cart-add-more-products"
			>
				{t("addMoreProducts")}
			</Button>
		</div>
	);
}
